/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {
  ButtonHTMLAttributes,
  useState,
  useCallback,
  useEffect,
  useRef,
} from 'react';
import { Container, ButtonContainer, DropdownContainer } from './styles';

interface DropdownIten {
  name: string;
  onClick(): void;
}

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  color: string;
  padding: string;
  itens: DropdownIten[];
}

const DropdownButton: React.FC<ButtonProps> = ({
  color,
  padding,
  itens,
  children,
  ...rest
}) => {
  const ref = useRef<any>(null);
  const [active, setActive] = useState<boolean>(false);
  const handleClickItem = useCallback((callback: any) => {
    callback();
    setActive(false);
  }, []);

  useEffect(() => {
    function handleClickOutside(event: any) {
      if (ref.current && !ref.current.contains(event.target)) {
        setActive(false);
      }
    }

    document.body.addEventListener('click', handleClickOutside);
    return () => {
      window.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <Container>
      <ButtonContainer
        color={color}
        padding={padding}
        onClick={() => setActive(!active)}
        type="button"
        ref={ref}
        {...rest}
      >
        {children}
      </ButtonContainer>
      <DropdownContainer active={active} onBlur={() => setActive(false)}>
        {itens.map(item => (
          <button
            type="button"
            key={item.name}
            onClick={() => handleClickItem(item.onClick)}
          >
            {item.name}
          </button>
        ))}
      </DropdownContainer>
    </Container>
  );
};

export default DropdownButton;
